import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner as HeroSpinner } from '@heroui/react';
export const Spinner = (props) => {
    return _jsx(HeroSpinner, { ...props });
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map